import React, { Component } from 'react';
import styled from 'styled-components';
import { FadeIn } from '../../../../../core/util/commonCssAnimations';
import { ie10Up } from '../../../../../core/util/styledComponents';
import SlotShape from '../../../../../shapes/Slot';
import Slot from '../SlotStates';
import { emptyFunction } from '../../../../../core/util/function';
import { safeGet } from '../../../../../core/util/object';
import { getAvailableSlots, getSlotSelectionProperties } from '../util';
import { EMPTY_ARRAY, isEmptyArray } from '../../../../../core/util/array';

const Container = styled.div.withConfig({ componentId: 'sc-1jhzbov-0' })`
  display: grid;
  grid-template-columns: repeat(4, auto);
  @media (max-width: 330px) {
    grid-template-columns: repeat(3, auto);
  }
  ${ie10Up`
    display: -ms-flexbox;
    -ms-flex-wrap: wrap;
  `}
`;

const SlotContainer = styled.div.withConfig({ componentId: 'sc-1jhzbov-1' })`
  margin: 4px;
  margin-top: 10px;
  animation: ${FadeIn} 300ms linear;
`;

const isSelected = (slot: any, selectedSlots = EMPTY_ARRAY) => {
  return selectedSlots.some((s: any) => s.appointmentDate === slot.appointmentDate);
};

type OwnFullTimeSlotGridProps = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'SlotShape' refers to a value, but is being used a... Remove this comment to see the full error message
  slots?: SlotShape[];
  timeZone?: string;
  className?: string;
  darkTheme?: boolean;
  handleSelectedSlot?: (...args: any[]) => any;
  // @ts-expect-error ts-migrate(2749) FIXME: 'SlotShape' refers to a value, but is being used a... Remove this comment to see the full error message
  selectedSlots?: SlotShape[];
  shouldSelectFirstSlotAsInitialValue?: boolean;
};

type FullTimeSlotGridProps = OwnFullTimeSlotGridProps & typeof FullTimeSlotGrid.defaultProps;

class FullTimeSlotGrid extends Component<FullTimeSlotGridProps> {
  static defaultProps = {
    handleSelectedSlot: emptyFunction,
  };

  componentDidMount = () => {
    const { selectedSlots, slots, shouldSelectFirstSlotAsInitialValue } = this.props;
    if (isEmptyArray(selectedSlots) && shouldSelectFirstSlotAsInitialValue) {
      const defaultSlot = safeGet(getAvailableSlots(slots))('0');
      if (defaultSlot) {
        this.handleSelect(defaultSlot);
      }
    }
  };

  handleSelect = (slot: any) => {
    if (slot.availability < 1) {
      return;
    }

    const { slots } = this.props;
    const selectionProperties = getSlotSelectionProperties(slots);
    this.props.handleSelectedSlot(slot, selectionProperties);
  };

  render() {
    const { slots, timeZone, className, darkTheme, selectedSlots } = this.props;

    return (
      <Container className={className} data-testid="slots-container">
        {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
        {slots.map((slot) => (
          <SlotContainer key={slot.appointmentDate} onClick={() => this.handleSelect(slot)}>
            <Slot
              darkTheme={darkTheme}
              isSelected={isSelected(slot, selectedSlots)}
              slot={slot}
              timeZone={timeZone}
            />
          </SlotContainer>
        ))}
      </Container>
    );
  }
}

export default FullTimeSlotGrid;
